import React from 'react'

const UnderPhone = () => {
  return (
    <div className='underPhone'>
        <div className='underPhoneLine'></div>
    </div>
  )
}

export default UnderPhone